import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { A11yModule } from '@angular/cdk/a11y';

import { NgxPaginationModule } from 'ngx-pagination';
import { TranslateModule } from './shared/services/translate';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppComponent } from './app.component';
import { CookieService } from 'ngx-cookie-service';

import { SharedModule } from './shared/shared.module';
import { AuthGuard } from './guard/authentication.service';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';

import { AssessmentListComponent } from './components/assessment-list/assessment-list.component';
import { SourceInfoComponent } from './components/source-info/source-info.component';
import { LoadingSpinnerModule } from './loading-spinner/loading-spinner.module';
import { GrdFilterPipe } from './shared/pipes/grd-filter.pipe';
import { SourceSelectComponent } from './components/source-select/source-select.component';
import { DeleteAssessmentComponent } from './components/delete-assessment/delete-assessment.component';
import { EditAssessmentComponent } from './components/edit-assessment/edit-assessment.component';
import { FilterTestCategoryComponent } from './components/filter-test-category/filter-test-category.component';
import { DateTimeFormatPipe } from './shared/pipes/date-time-formattor.pipe';
import { CdkAccordionModule } from '@angular/cdk/accordion';

const appRoutes: Routes = [
  { path: '', redirectTo: '/list', pathMatch: 'full' as Route['pathMatch'] },
  { path: 'testbuilder/lti/launch', component: AssessmentListComponent },
  { path: 'list', component: AssessmentListComponent },
  { path: 'source', component: SourceInfoComponent },
  { path: 'sourceSelect', component: SourceSelectComponent },
  { path: 'source/:id', component: SourceInfoComponent },
  { path: 'deleteAssessment/:id', component: DeleteAssessmentComponent },
  { path: 'editAssessment', component: EditAssessmentComponent },
  { path: 'editAssessment/:operationMode', component: EditAssessmentComponent }
];

@NgModule({
    declarations: [
        AppComponent,
        AssessmentListComponent,
        GrdFilterPipe,
        DateTimeFormatPipe,
        SourceInfoComponent,
        SourceSelectComponent,
        DeleteAssessmentComponent,
        EditAssessmentComponent,
        FilterTestCategoryComponent
    ],
    exports: [
        DragDropModule,
    ],
    bootstrap: [AppComponent],
    imports: [
        A11yModule,
        BrowserAnimationsModule,
        FormsModule,
        BrowserModule,
        NgxPaginationModule,
        SharedModule,
        LoadingSpinnerModule,
        RouterModule.forRoot(appRoutes, {}),
        ReactiveFormsModule,
        TranslateModule.forRoot(),
        DragDropModule,
        CdkAccordionModule
    ],
    providers: [AuthGuard, CookieService, GrdFilterPipe,
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
      provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
